export default __webpack_public_path__ + "static/media/post-ops.2756370c.svg";